<template>
  <v-menu
    v-model="show"
    transition="slide-x-reverse-transition"
    :close-on-content-click="false"
    :right="true"
    origin="top right"
    lazy
    :disabled="disabled"
  >
    <div slot="activator" class="app-field-value px-2 py-1">
      <MongoDataTableItemField :item="value" :itemSchema="fieldType" />
    </div>
    <v-card>
      <v-card-title>
        <span class="mt-3 title">{{ title }}</span>
      </v-card-title>
      <v-card-text class="py-0">
        <MongoForm
          ref="form"
          v-model="form"
          :defaultForm="defaultForm"
          :flatSchema="flatSchema"
          :mongooseSchema="service.mongooseSchema"
          rowClasses="flex xs12"
          :showDetails="false"
          :flat="true"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" flat @click="show = false">Close</v-btn>
        <v-btn color="primary darken-1" dark @click="save" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import MongoConnector from '../../services/mongo-connector.service'
  import MongoForm from './MongoForm'
  import MongoDataTableItemField from './MongoDataTableItemField'
  import { unflattenObject, parseFormInputValue } from '../../libs/utils'

  export default {
    props: {
      value: { required: false },
      disabled: { required: false, default: false },
      title: { required: false, default: '' },
      doc: { required: false, type: Object },
      field: { required: false, type: String },
      service: { type: MongoConnector, required: false, default: null }
    },
    data () {
      return {
        loading: false,
        show: false,
        form: {},
        defaultForm: {}
      }
    },
    watch: {
      show (isShow) {
        if (isShow) {
          this.open()
        } else {
          this.close()
        }
      }
    },
    computed: {
      flatSchema () {
        return {
          [this.field]: this.service.flatSchema[this.field]
        }
      },
      inputValue () {
        return this.form[this.field]
      },
      fieldType () {
        return this.flatSchema[this.field].type
      }
    },
    methods: {
      open () {
        this.loading = false
        this.defaultForm = unflattenObject({
          [this.field]: parseFormInputValue(this.fieldType, this.value)
        })
      },
      close () {
        this.$refs.form.reset()
      },
      async save () {
        const valid = this.$refs.form.submit()
        if (valid) {
          try {
            const { value, inputValue, doc, field, service } = this
            console.log('editted', { field, from: value, to: inputValue })
            if (doc && field && service) {
              this.loading = true
              doc[field] = inputValue
              await service.updateDocuments({
                _id: doc._id,
                ...doc
              })
            }
            this.$emit('input', inputValue)
            this.$emit('update', inputValue)
          } catch (e) {
            console.error(e)
          }
          this.loading = false
          this.show = false
        }
      }
    },
    components: {
      MongoForm,
      MongoDataTableItemField
    }
  }
</script>

<style lang="scss" scoped>
  .app-field-value {
    cursor: pointer;
    border-radius: .33em;
    &:hover {
      background-color: rgba(0, 0, 0, .05);
    }
  }
</style>


